import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Stack, SxProps, Typography } from "@mui/material";
import { useState } from "react";
import { faqItems } from "../../data/faq";
import { ContactUsText } from "../../data/texts";
import CollapseAccordion, {
  CollapseAccordionSlots,
} from "../common/collapse-accordion/CollapseAccordion";

interface FaqProps {
  sx?: SxProps;
}
const Faq = ({ sx }: FaqProps) => {
  const [expandedId, setExpandedId] = useState<string>(faqItems[0].id);
  const handleCollapse = (id: string) => {
    setExpandedId(id);
  };
  return (
    <Stack
      gap={"10px"}
      sx={{
        ...sx,
        borderRadius: "8px",
        boxShadow: "0px 2px 6px 0px #4C4E641A",
        background: "white",
        padding: "20px",
      }}
    >
      <Typography sx={{ textAlign: "center" }}>{ContactUsText.FAQ}</Typography>
      <Typography
        sx={{ textAlign: "center", fontWeight: "200", marginBottom: "20px" }}
      >
        {ContactUsText.FAQ_SUBTITLE}
      </Typography>
      {faqItems.map((item) => (
        <CollapseAccordion
          key={item.id}
          expandedId={expandedId}
          id={item.id}
          handleCollapse={handleCollapse}
          sx={{ border: "1px #4C4E641F solid" }}
        >
          <slot name={CollapseAccordionSlots.HEADER}>
            <Stack
              flexDirection={"row"}
              justifyContent={"space-between"}
              sx={{ padding: "20px" }}
            >
              <Typography sx={{ color: "black" }}>{item.title}</Typography>
              {expandedId === item.id ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </Stack>
          </slot>
          <slot name={CollapseAccordionSlots.CONTENT}>
            <Typography
              sx={{ padding: "10px", color: "black", fontWeight: "300" }}
            >
              {item.text}
            </Typography>
          </slot>
        </CollapseAccordion>
      ))}
    </Stack>
  );
};

export default Faq;
